export default __webpack_public_path__ + "static/media/projects-icon.81efdee1.svg";